export default __webpack_public_path__ + "static/media/Unicodepinguin.320e4bc4.png";